"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMoment = exports.isPublicMoment = exports.getPublicMoment = void 0;

var react_1 = __importDefault(require("react"));

var moment_1 = __importDefault(require("../constants/moment"));

var icon_1 = require("./icon");

var getPublicMoment = function getPublicMoment(_a) {
  var type = _a.type;
  return moment_1.default[type];
};

exports.getPublicMoment = getPublicMoment;

var isPublicMoment = function isPublicMoment(momentData) {
  return !!(0, exports.getPublicMoment)(momentData);
};

exports.isPublicMoment = isPublicMoment;

var buildMoment = function buildMoment(story, momentData, index) {
  var MomentComponent = (0, exports.getPublicMoment)(momentData);

  if (!MomentComponent) {
    return undefined;
  }

  var iconData = momentData.icon,
      label = momentData.label;
  var icon = (0, icon_1.buildIcon)(iconData);
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(MomentComponent, __assign({
    key: "moment-" + index + "-" + label
  }, momentData, {
    icon: icon,
    index: index,
    story: story
  }));
};

exports.buildMoment = buildMoment;